export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/pet.833e8368.svg","height":111,"width":122,"blurWidth":0,"blurHeight":0};